/* Ledger theme — core behaviour. No dependencies. */
(function () {
  'use strict';

  var cfg = window.Ledger || {};
  var S = cfg.settings || {};
  var STR = cfg.strings || {};
  var R = cfg.routes || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function raf(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { fn(); ticking = false; });
    };
  }

  /* ---------------------------------------------------------------- Toast */
  var toastEl = null;
  var toastTimer = null;
  function toast(msg) {
    toastEl = toastEl || $('[data-toast]');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }

  /* --------------------------------------------------------------- Header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    var last = 0;
    var onScroll = raf(function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-stuck', y > 12);
      last = y;
    });
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    /* Desktop dropdowns — hover + keyboard */
    $$('[data-nav-item]', header).forEach(function (item) {
      var trigger = $('[data-nav-trigger]', item);
      var panel = $('.nav__panel', item);
      if (!trigger || !panel) return;

      var close = function () { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
      var open = function () { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };

      on(item, 'mouseenter', open);
      on(item, 'mouseleave', close);
      on(trigger, 'click', function (e) {
        e.preventDefault();
        item.classList.contains('is-open') ? close() : open();
      });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
      on(item, 'keydown', function (e) {
        if (e.key === 'Escape') { close(); trigger.focus(); }
      });
    });
  }

  /* --------------------------------------------------------------- Drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    var scrim = $('[data-scrim]');
    var openBtn = $('[data-drawer-open]');
    var closeBtn = $('[data-drawer-close]');
    if (!drawer || !openBtn) return;

    function open() {
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.classList.add('no-scroll');
      openBtn.setAttribute('aria-expanded', 'true');
      var first = $('a, button', drawer);
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    on(openBtn, 'click', open);
    on(closeBtn, 'click', close);
    on(scrim, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    $$('[data-drawer-toggle]', drawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var sub = btn.nextElementSibling;
        if (!sub) return;
        var open = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------------------------- Search */
  function initSearch() {
    var overlay = $('[data-search-overlay]');
    var openBtns = $$('[data-search-open]');
    var closeBtn = $('[data-search-close]');
    if (!overlay || !openBtns.length) return;

    var input = $('[data-search-input]', overlay);
    var results = $('[data-search-results]', overlay);
    var footer = $('[data-search-foot]', overlay);
    var controller = null;

    function open() {
      overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    openBtns.forEach(function (b) { on(b, 'click', open); });
    on(closeBtn, 'click', close);
    on(overlay, 'click', function (e) { if (e.target === overlay) close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
    });

    if (!S.predictiveSearch || !input || !results) return;

    var render = function (items, term) {
      if (!items.length) {
        results.innerHTML = '<p class="search-overlay__empty">No guides matched “' + escapeHtml(term) + '”.</p>';
        if (footer) footer.hidden = true;
        return;
      }
      results.innerHTML = items.map(function (a) {
        var img = a.image
          ? '<img src="' + a.image + '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="search-result__ph"></span>';
        return '<a class="search-result" href="' + a.url + '">' + img +
          '<span><span class="search-result__title">' + escapeHtml(a.title) + '</span>' +
          '<span class="search-result__meta">' + escapeHtml(a.meta || '') + '</span></span></a>';
      }).join('');
      if (footer) {
        footer.hidden = false;
        var link = $('a', footer);
        if (link) link.href = R.search + '?q=' + encodeURIComponent(term) + '&type=article';
      }
    };

    var query = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; if (footer) footer.hidden = true; return; }

      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = (R.predictive || '/search/suggest') +
        '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=article,page&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          var items = [];
          (res.articles || []).forEach(function (a) {
            items.push({
              title: a.title,
              url: a.url,
              image: a.image ? a.image : null,
              meta: (a.summary_html ? stripTags(a.summary_html).slice(0, 70) : 'Guide')
            });
          });
          (res.pages || []).forEach(function (p) {
            items.push({ title: p.title, url: p.url, image: null, meta: 'Page' });
          });
          render(items, term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results.innerHTML = '';
        });
    }, 220);

    on(input, 'input', query);
  }

  function stripTags(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent || '';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --------------------------------------------------------------- Reveal */
  var revealObserver = null;
  function initReveal(root) {
    if (!S.animations || reduced || !('IntersectionObserver' in window)) {
      $$('.reveal', root).forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    $$('.reveal:not(.is-visible)', root).forEach(function (el, i) {
      var group = el.closest('[data-stagger]');
      if (group && !el.style.getPropertyValue('--delay')) {
        var siblings = $$('.reveal', group);
        var idx = siblings.indexOf(el);
        el.style.setProperty('--delay', Math.min(idx, 8) * 70 + 'ms');
      }
      revealObserver.observe(el);
    });
  }

  /* -------------------------------------------------------------- Count-up */
  function initCounters(root) {
    var els = $$('[data-count]', root);
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = formatCount(el, parseFloat(el.dataset.count)); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function formatCount(el, val) {
    var dec = parseInt(el.dataset.decimals || '0', 10);
    var out = val.toFixed(dec);
    if (el.dataset.separator !== 'false') {
      var parts = out.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      out = parts.join('.');
    }
    return (el.dataset.prefix || '') + out + (el.dataset.suffix || '');
  }

  function countUp(el) {
    var target = parseFloat(el.dataset.count) || 0;
    var dur = 1500;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = formatCount(el, target * eased);
      if (p < 1) window.requestAnimationFrame(step);
      else el.textContent = formatCount(el, target);
    }
    window.requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------ Accordions */
  function initAccordions(root) {
    $$('[data-accordion] [data-accordion-trigger]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('[data-accordion]');
        if (group && group.dataset.single === 'true' && !expanded) {
          $$('[data-accordion-trigger]', group).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
        }
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ------------------------------------------------------------ Disclosure */
  function initDisclosure(root) {
    $$('[data-disclosure]', root).forEach(function (wrap) {
      var btn = $('[data-disclosure-btn]', wrap);
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function (e) {
        e.stopPropagation();
        wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', wrap.classList.contains('is-open') ? 'true' : 'false');
      });
      on(document, 'click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ------------------------------------------------------------- Copy link */
  function initCopy(root) {
    $$('[data-copy-link]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function () {
        var url = btn.dataset.url || window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { toast(STR.copied || 'Link copied'); });
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); toast(STR.copied || 'Link copied'); } catch (e) { /* noop */ }
          document.body.removeChild(ta);
        }
      });
    });
  }

  /* ------------------------------------------------- Article: TOC + progress */
  function initArticle() {
    var body = $('[data-article-body]');
    if (!body) return;

    /* Inject IDs on headings */
    var headings = $$('h2, h3', body).filter(function (h) { return h.textContent.trim().length > 2; });
    var used = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = h.textContent.trim().toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-')
          .slice(0, 60) || 'section';
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
        used[id] = true;
        h.id = id;
      }
    });

    /* Build TOC */
    var tocWrap = $('[data-toc]');
    var tocList = $('[data-toc-list]');
    if (tocWrap && tocList) {
      if (headings.length < 2) {
        tocWrap.hidden = true;
      } else {
        tocList.innerHTML = headings.map(function (h) {
          var cls = 'toc__link' + (h.tagName === 'H3' ? ' toc__link--h3' : '');
          return '<a class="' + cls + '" href="#' + h.id + '" data-toc-link>' + escapeHtml(h.textContent.trim()) + '</a>';
        }).join('');

        var links = $$('[data-toc-link]', tocList);
        if ('IntersectionObserver' in window) {
          var spy = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              links.forEach(function (l) {
                l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
              });
            });
          }, { rootMargin: '-15% 0px -70% 0px' });
          headings.forEach(function (h) { spy.observe(h); });
        }
      }
    }

    /* Reading progress */
    var bar = $('[data-progress]');
    if (bar && S.progressBar) {
      var fill = $('span', bar);
      var onScroll = raf(function () {
        var rect = body.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.4;
        var passed = -rect.top + window.innerHeight * 0.25;
        var pct = total > 0 ? Math.max(0, Math.min(1, passed / total)) : 0;
        if (fill) fill.style.width = (pct * 100).toFixed(2) + '%';
      });
      on(window, 'scroll', onScroll, { passive: true });
      on(window, 'resize', onScroll);
      onScroll();
    }

    /* Inline CTA injection */
    var tpl = $('#InlineCTATemplate');
    if (tpl && S.inlineCta && 'content' in tpl) {
      var after = parseInt(S.inlineCtaAfter || 2, 10);
      var h2s = $$('h2', body);
      if (h2s.length > after) {
        var anchor = h2s[after];
        var node = tpl.content.cloneNode(true);
        anchor.parentNode.insertBefore(node, anchor);
      } else if (body.children.length > 4) {
        body.appendChild(tpl.content.cloneNode(true));
      }
    }

    /* External links in article get rel + target */
    $$('a[href^="http"]', body).forEach(function (a) {
      if (a.hostname && a.hostname !== window.location.hostname) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener nofollow');
      }
    });

    /* Wrap tables for horizontal scroll on mobile */
    $$('table', body).forEach(function (t) {
      if (t.parentNode.classList.contains('table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'table-scroll';
      wrap.style.overflowX = 'auto';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });
  }

  /* ---------------------------------------------------------- Back to top */
  function initBackToTop() {
    var btn = $('[data-to-top]');
    if (!btn) return;
    var onScroll = raf(function () {
      btn.classList.toggle('is-visible', window.pageYOffset > 700);
    });
    on(window, 'scroll', onScroll, { passive: true });
    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
    onScroll();
  }

  /* ------------------------------------------------------------ Calculator */
  function initCalculators(root) {
    $$('[data-calc]', root).forEach(function (calc) {
      if (calc.dataset.bound) return;
      calc.dataset.bound = '1';

      var amount = $('[data-calc-amount]', calc);
      var rate = $('[data-calc-rate]', calc);
      var termBtns = $$('[data-calc-term]', calc);

      var amountOut = $('[data-calc-amount-out]', calc);
      var rateOut = $('[data-calc-rate-out]', calc);

      var payOut = $('[data-calc-payment]', calc);
      var totalOut = $('[data-calc-total]', calc);
      var interestOut = $('[data-calc-interest]', calc);
      var principalOut = $('[data-calc-principal]', calc);
      var costOut = $('[data-calc-cost]', calc);
      var barP = $('[data-calc-bar-principal]', calc);
      var barI = $('[data-calc-bar-interest]', calc);

      var term = parseInt(calc.dataset.term || '24', 10);

      var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: calc.dataset.currency || cfg.currency || 'USD',
        maximumFractionDigits: 0
      });
      var money2 = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: calc.dataset.currency || cfg.currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });

      function paintRange(input) {
        if (!input) return;
        var min = parseFloat(input.min) || 0;
        var max = parseFloat(input.max) || 100;
        var val = parseFloat(input.value) || 0;
        var pct = ((val - min) / (max - min)) * 100;
        input.style.setProperty('--fill', pct + '%');
      }

      function compute() {
        var P = parseFloat(amount ? amount.value : 50000) || 0;
        var annual = parseFloat(rate ? rate.value : 12) || 0;
        var n = term;
        var r = annual / 100 / 12;

        var monthly;
        if (r === 0) monthly = P / n;
        else monthly = (P * r) / (1 - Math.pow(1 + r, -n));

        var total = monthly * n;
        var interest = total - P;

        if (amountOut) amountOut.textContent = money.format(P);
        if (rateOut) rateOut.textContent = annual.toFixed(1) + '%';
        if (payOut) payOut.textContent = money2.format(Math.round(monthly));
        if (totalOut) totalOut.textContent = money2.format(Math.round(total));
        if (interestOut) interestOut.textContent = money2.format(Math.round(interest));
        if (principalOut) principalOut.textContent = money2.format(Math.round(P));
        if (costOut) costOut.textContent = (P > 0 ? (interest / P * 100).toFixed(1) : '0.0') + '%';

        var pShare = total > 0 ? (P / total) * 100 : 100;
        if (barP) barP.style.width = pShare + '%';
        if (barI) barI.style.width = (100 - pShare) + '%';

        paintRange(amount);
        paintRange(rate);
      }

      on(amount, 'input', compute);
      on(rate, 'input', compute);

      termBtns.forEach(function (btn) {
        on(btn, 'click', function () {
          termBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          term = parseInt(btn.dataset.calcTerm, 10);
          compute();
        });
      });

      compute();
    });
  }

  /* ------------------------------------------------------- Smooth anchors */
  function initAnchors() {
    on(document, 'click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.getElementById(id.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', id);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  /* ---------------------------------------------------------------- Boot */
  function boot(root) {
    root = root || document;
    initReveal(root);
    initCounters(root);
    initAccordions(root);
    initDisclosure(root);
    initCopy(root);
    initCalculators(root);
  }

  function init() {
    initHeader();
    initDrawer();
    initSearch();
    initArticle();
    initBackToTop();
    initAnchors();
    boot(document);
    document.dispatchEvent(new CustomEvent('ledger:ready'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initDrawer();
    initSearch();
    boot(e.target);
    document.dispatchEvent(new CustomEvent('ledger:ready'));
  });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var blk = e.target;
    if (blk && blk.classList) blk.classList.add('is-visible');
  });

  window.Ledger.toast = toast;
})();
